<template lang="pug">
.spinner
</template>

<script>
export default {
  name: 'spinner',
};
</script>

<style lang="scss" scoped>
// https://projects.lukehaas.me/css-loaders/
.spinner,
.spinner:after {
  border-radius: 50%;
  width: 10em;
  height: 10em;
}
.spinner {
  margin: 0 auto 60px auto;
  font-size: 10px;
  position: relative;
  top: 60px;
  text-indent: -9999em;
  border-top: 1.1em solid rgba(0,150,214, 0.2);
  border-right: 1.1em solid rgba(0,150,214, 0.2);
  border-bottom: 1.1em solid rgba(0,150,214, 0.2);
  border-left: 1.1em solid #0096d6;
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);
  -webkit-animation: load8 1.1s infinite linear;
  animation: load8 1.1s infinite linear;
}
@-webkit-keyframes load8 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes load8 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Spinner.vue